import { useEffect, useCallback } from 'react';
import { clamp } from '../utils';
import { useUI } from '../contexts';

export function useEditorResize() {
  const {
    editorHeight,
    setEditorHeight,
    editorResizeRef,
    editorResizeRaf,
  } = useUI();
  useEffect(() => {
    const handleMove = (e: MouseEvent) => {
      if (!editorResizeRef.current.dragging) return;
      if (editorResizeRaf.current) cancelAnimationFrame(editorResizeRaf.current);
      editorResizeRaf.current = requestAnimationFrame(() => {
        const dy = e.clientY - editorResizeRef.current.startY;
        const next = clamp(editorResizeRef.current.startHeight + dy, 220, 900);
        setEditorHeight(next);
      });
    };
    const handleUp = () => {
      if (editorResizeRef.current.dragging) {
        editorResizeRef.current = { dragging: false, startY: 0, startHeight: editorHeight };
        document.body.style.cursor = '';
        if (editorResizeRaf.current) {
          cancelAnimationFrame(editorResizeRaf.current);
          editorResizeRaf.current = null;
        }
      }
    };
    window.addEventListener('mousemove', handleMove);
    window.addEventListener('mouseup', handleUp);
    return () => {
      window.removeEventListener('mousemove', handleMove);
      window.removeEventListener('mouseup', handleUp);
    };
  }, [editorHeight, editorResizeRef, editorResizeRaf, setEditorHeight]);

  const startEditorResize = useCallback(
    (startY: number) => {
      editorResizeRef.current = {
        dragging: true,
        startY,
        startHeight: editorHeight,
      };
      document.body.style.cursor = 'row-resize';
    },
    [editorHeight, editorResizeRef]
  );

  return { startEditorResize };
}
